// extracted by mini-css-extract-plugin
export default {"fitGuideButton":"Vm7kp"};